<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <div class="widget-heading">
                    <div class="row">
                        <div class="col-12 d-inline-flex align-items-center">
                            <h4 class="me-3 my-0">Maszyny w SMART</h4>
                       </div>
                    </div>
                </div>
                <div class="widget-content">
                    <div class="custom-table col-9">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nazwa</th>
                                        <th style="min-width:100px;">Pobór KW/h</th>
                                        <th>Hala</th>
                                        <th style="min-width:120px;">Opcje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(maszyna, index) in maszynyLocal" :key="maszyna.smart_id">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ maszyna.nazwa }}</td>
                                        <td>{{ maszyna.kwh ?? '-' }}</td>
                                        <td>{{ maszyna.hala_nazwa ?? '-' }}</td>
                                        <td>
                                            <button v-if="hasPermission('canEditMaszyny')" @click="editMaszyna(maszyna)" class="btn btn-sm btn-outline-info me-2 mb-2"><i class="bi bi-pencil me-2"></i>Edytuj kW/h</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Dodaj maszynę</h5>
                                    <button type="button" class="btn-close" @click="closeModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <label class="form-label" for="smart_id">Maszyna:</label>
                                            <select id="smart_id" v-model="newMaszyna.smart_id" class="form-select">
                                                <option :value="null">-- wybierz maszynę --</option>
                                                <option v-for="maszyna in smartMaszyny" :key="maszyna.ID_Machine" :value="maszyna.ID_Machine">
                                                    {{ maszyna.Nazwa }} (SMART ID: {{ maszyna.ID_Machine }})
                                                </option>
                                            </select>
                                        </div>

                                        <div class="col-md-4">
                                            <label class="form-label" for="kwh">Pobór energii kW/h:</label>
                                            <input id="kwh" v-model="newMaszyna.kwh" class="form-control" type="number"
                                                step="0.01" min="0" />
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                                    <button class="btn btn-primary" @click="saveNewMaszyna">Zapisz</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Edycja poboru energii</h5>
                                    <button type="button" class="btn-close" @click="closeEditModal"></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="form-label">Maszyna:</label>
                                            <input :value="editedMaszyna.nazwa" class="form-control" disabled />
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Smart ID:</label>
                                            <input :value="editedMaszyna.smart_id" class="form-control" disabled />
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Hala:</label>
                                            <input :value="editedMaszyna.hala_nazwa ?? '-'" class="form-control" disabled />
                                        </div>
                                        <div class="col-md-6 mt-3">
                                            <label class="form-label" for="edit_kwh">Pobór energii kW/h:</label>
                                            <input id="edit_kwh" v-model="editedMaszyna.kwh" class="form-control" type="number" step="0.01" min="0" />
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger" @click="closeEditModal">
                                        Anuluj
                                    </button>
                                    <button type="button" class="btn btn-primary" @click="updateMaszyna(editedMaszyna)">
                                        Zapisz
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasPermission } = usePermission();

export default {
    components: { AppLayout },

    props: {
        maszyny: {
            type: Array,
            default: () => []
        },
        smartMaszyny: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            hasPermission,
            editingId: null,
            addingNew: false,
            newMaszyna: this.getEmptyForm(),
            editedMaszyna: {},
            isModalOpen: false,
            isEditModalOpen: false,
            maszynyLocal: [...this.maszyny],
        };
    },
    watch: {
        maszyny: {
            handler(nowe) {
                this.maszynyLocal = [...nowe]; // aktualizacja jeśli props się zmieni
            },
            immediate: true
        }
    },

    methods: {
        async openModal() {
            this.isModalOpen = true;
        },

        closeModal() {
            this.isModalOpen = false;
            this.newMaszyna = this.getEmptyForm();
            this.addingNew = false;
            this.editingId = null;
        },

        closeEditModal() {
            this.isEditModalOpen = false;
        },

        getEmptyForm() {
            return {
                smart_id: null,
                kwh: null,
            };
        },

        addMaszyna() {
            this.addingNew = true;
            this.newMaszyna = this.getEmptyForm();
        },
        cancelNewMaszyna() {
            this.addingNew = false;
            this.newMaszyna = this.getEmptyForm();
        },
        editMaszyna(maszyna) {
            this.editingId = maszyna.id;
            this.isEditModalOpen = true;
            this.editedMaszyna = maszyna;

        },

		updateMaszyna(dane) {
			this.$inertia.put(
				route('production.machine.update', dane.smart_id),
				{
					kwh: dane.kwh
				},
				{
					onSuccess: () => {
						this.editedMaszyna = {};
						this.isEditModalOpen = false;
					}
				}
			);
		},

        saveNewMaszyna() {
            this.$inertia.post(
                route('production.machine.add'),
                {
                    smart_id: this.newMaszyna.smart_id,
                    kwh: this.newMaszyna.kwh,
                },
                {
                    onSuccess: () => {
                        this.newMaszyna = this.getEmptyForm();
                        this.isModalOpen = false;
                        this.addingNew = false;
                    }
                }
            );
        },
    }
};
</script>
<style scoped></style>
